import { Directive, HostListener, ElementRef, OnInit } from '@angular/core';

@Directive({
  selector: '[appNumberFormat]'
})
export class NumberFormatDirective implements OnInit {

  constructor(private el: ElementRef) { }

  ngOnInit() {
    this.formatInitialValue();
  }

  @HostListener('input', ['$event'])
  onInput(event: Event) {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let value: string = inputElement.value;
    inputElement.value = this.formatNumber(value);
  }

  private formatNumber(value: string): string {
    value = value.replace(/[^0-9]/g, '');
    value = value.replace(/^0+/, '');
    return value.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  private formatInitialValue() {
    const inputElement = this.el.nativeElement as HTMLInputElement;
    let value: string = inputElement.value;
    if (value) {
      inputElement.value = this.formatNumber(value);
    }
  }
}
